import styled from 'styled-components'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import ExampleComponent from '../ExampleComponent'
import { Strong } from '../../theme/styles'
import useScrollStore from '../useScrollStore'
import { useRef } from 'react'
import Dimmer from 'components/Dimmer'
import { StepContent, StepContainer } from '../../theme/styles'

const TreeScroll = () => {
  const scrollyTellingContainer = useRef<HTMLDivElement>(null)

  // When the user scrolls to a new step, update the scrollStage in the store
  const onStepEnter = (stepData: any) => {
    useScrollStore.setState({ scrollStage: stepData.data })
  }

  // When the user scrolls within a step, update the scrollPct in the store
  const onStepProgress = (stepData: any) => {
    useScrollStore.setState({
      scrollPct: Math.min(
        1,
        Math.max((stepData.data - 1) / 5 + stepData.progress / 5, 0)
      ),
      scrollStagePct: stepData.progress,
    })
  }

  console.log('RENDER TreeScroll')

  return (
    <Scrollyrtelling>
      <Dimmer targetRef={scrollyTellingContainer} />
      <StickyChart ref={scrollyTellingContainer}>
        <ExampleComponent />
      </StickyChart>
      <ScrollytellingContainer>
        <Scrollama
          offset={1}
          onStepEnter={onStepEnter}
          onStepProgress={onStepProgress}
        >
          <Step data={0} key={`scrollama-step-${0}`}>
            <StepContainer style={{ height: '25vh' }} />
          </Step>
          <Step data={1} key={`scrollama-step-${1}`}>
            <StepContainer>
              <StepContent>
                <p>
                  En 2023, ce marronnier de la réserve naturelle des Douves, à la frontières des cantons de Vaud et Genève, a
                  déployé ses feuilles au <Strong>milieu du mois d'avril</Strong>.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={2} key={`scrollama-step-${2}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Ses <Strong>premières fleurs</Strong> sont apparues quelques
                  jours plus tard.
                </p>
                <p>
                  Et c'est seulement en octobre que les premières feuilles ont commencé à jaunir avant de tomber.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={3} key={`scrollama-step-${3}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Toutefois il y a quelques années, notre marronnier a connu des
                  phases de développement très différentes.
                </p>
                <p>
                  En 2008, ses feuilles sont apparues près{' '}
                  <Strong color='yellow'>d'un mois plus tôt</Strong>.
                  Nous étions encore en hiver.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={4} key={`scrollama-step-${4}`}>
            <StepContainer>
              <StepContent>
                <p>
                  L'apparition des fleurs et le jaunissement des feuilles
                  ont aussi été très précoces en 2008. L'arbre a cependant
                  commencé à se{' '}
                  <Strong color='yellow'>dénuder plus tardivement</Strong>.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={5} key={`scrollama-step-${5}`}>
            <StepContainer>
              <StepContent>
                <p>
                  D'une année à l'autre, les dates de passage aux différents
                  phases de la nature peuvent énormément varier.
                </p>
                <p>
                  Mais une tendance se dessine: au fil des années, la
                  nature verdit de plus en plus tôt.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          {/* <Step data={6} key={`scrollama-step-${6}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Toutefois, ce graphique ne montre pas la part de retraités qui
                  renoncent aux prestations complémentaires.
                </p>
                <p>
                Alors les dés du climat sont-ils pipés?
                  <Strong>20% de femmes et 11% d'hommes</Strong>.
                </p>
              </StepContent>
            </StepContainer>
          </Step> */}
        </Scrollama>
      </ScrollytellingContainer>
    </Scrollyrtelling>
  )
}

const StickyChart = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

const Scrollyrtelling = styled.div`
  position: relative;
  z-index: 1;
`

const ScrollytellingContainer = styled.div`
  position: relative;
  width: 100%;
  pointer-events: none;
  margin-top: -120vh;
`

export default TreeScroll
